import React from 'react';
import { View } from 'react-native';
import { arrangeScreenInJson } from '../../../screens/ScreensOrdering';
import FullPagePanel from '../General/FullPagePanel';
import SwitcherPanel from '../Buttons/SwitcherPanel';
import BreakLine from '../General/BreakLine';
import RadioPanelRecipient from '../Buttons/RadioPanelRecipient';
import ContactListMenu from '../ContactListDesign/ContactListMenu';
import NoteMessage from '../Text/NoteMessage';
import {
  addPathToList, customer_select_recipient_transfer, From_list_manually,
  getSubCategoryId, List_only_str, Manually_only_str,
  recipient_disabled_add_manually, Recipient_list, select_recipient,
  Select_recipient_disabled_step_skipped, skip_contact_list,
} from '../../../utils/DictionaryManagementUtils';

//= ========================================================================

const DefaultRecipientList = ({
  globJSON,
  onConfigChanged,
  selectedScreen,
  onStepPressed,
  onGotoEdit,
  paragraph,
  language,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({
    sub_category: myScreen.sub_category,
    duplication_number: 0,
  });
  const service = globJSON.configurations.services[subCategoryId];
  const { recipient } = service;
  const request = recipient.customer_should_select_recipient_request;
  const list = recipient.select_from_recipients_list;
  const manually = recipient.add_recipient_manually;

  const editTextList = [
    'select_contact_title',
    'search_contact_hint',
  ];
  const onValueChanged = (key, value) => {
    recipient[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={select_recipient}
      panelSubHeadline={Recipient_list}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/recipient/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/recipient/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={paragraph}
      isHollow
      disableEditElements={!list || !request}
      language={language}
    >
      <SwitcherPanel
        text={customer_select_recipient_transfer}
        value={request}
        onValueChanged={(value) => {
          onValueChanged('customer_should_select_recipient_request', value);
        }}
      />
      {request
            && (
            <View>
              <BreakLine />
              <RadioPanelRecipient
                valueLeft={list && manually}
                valueMiddle={list && !manually}
                valueRight={!list && manually}
                headlineLeftOption={From_list_manually}
                headlineMiddleOption={List_only_str}
                headlineRightOption={Manually_only_str}
                onPressLeftOption={() => {
                  onValueChanged('select_from_recipients_list', true);
                  onValueChanged('add_recipient_manually', true);
                }}
                onPressMiddleOption={() => {
                  onValueChanged('select_from_recipients_list', true);
                  onValueChanged('add_recipient_manually', false);
                }}
                onPressRightOption={() => {
                  onValueChanged('select_from_recipients_list', false);
                  onValueChanged('add_recipient_manually', true);
                }}
                language={language}
              />
              {list
                    && (
                    <View>
                      <BreakLine />
                      <SwitcherPanel
                        text={skip_contact_list}
                        value={recipient.skip_contact_list_when_empty}
                        onValueChanged={(value) => {
                          onValueChanged('skip_contact_list_when_empty', value);
                        }}
                      />
                      <ContactListMenu
                        globJSON={globJSON}
                        onConfigChanged={onConfigChanged}
                        selectedScreen={selectedScreen}
                      />
                    </View>
                    )}
              {!list && <NoteMessage language={language}>{recipient_disabled_add_manually}</NoteMessage>}
            </View>
            )}
      {!request && <NoteMessage language={language}>{Select_recipient_disabled_step_skipped}</NoteMessage>}
    </FullPagePanel>
  );
};

export default DefaultRecipientList;
